import { Injectable } from '@angular/core';

import { SignCredentials } from '@ap/sign';

import { DigicodeHerstelNotification } from '../klant/digicode-herstel/digicode-herstel.model';
import { ErrorContext } from '../klant/login/error/error.model';

/**
 * @ngdoc service
 * @name MijnLoginService
 * @module MijnLoginModule
 *
 * @description
 * Service for performing login and redirect related business logic
 */
@Injectable({
    providedIn: 'root'
})
export class MijnLoginService {
    private changeUsername: boolean;
    private errorContext = ErrorContext.ERROR;
    private keyChainId: string;
    private notificationMessage: DigicodeHerstelNotification;
    private signCredentials: SignCredentials;

    public isChangeUsername(): boolean {
        return this.changeUsername;
    }

    public setChangeUsername(changeUsername: boolean): void {
        this.changeUsername = changeUsername;
    }

    public getNotificationMessage(): DigicodeHerstelNotification {
        return this.notificationMessage;
    }

    public setNotificationMessage(notification: DigicodeHerstelNotification): void {
        this.notificationMessage = notification;
    }

    public getSignCredentials(): SignCredentials {
        return this.signCredentials;
    }

    public setSignCredentials(signCredentials: SignCredentials): void {
        this.signCredentials = signCredentials;
    }

    public getKeyChainId(): string {
        return this.keyChainId;
    }

    public setKeyChainId(keyChainId: string): void {
        this.keyChainId = keyChainId;
    }

    public getErrorContext(): ErrorContext {
        return this.errorContext;
    }

    public setErrorContext(context: ErrorContext): void {
        this.errorContext = context;
    }
}
